// frontend/src/services/usuarioService.js
import apiClient from './apiClient';

const getAll = () => {
    return apiClient.get('/usuarios');
};

// Lista mínima de usuarios (id, nombre, rol, validado), sin el permiso de administración que
// exige getAll(). Pensada para selectores operativos (ej: elegir un abogado apoderado en un
// turno ANSES, o quién atiende una videollamada) donde cualquier rol autenticado necesita ver
// los nombres del resto del equipo pero no la gestión completa de usuarios.
const getParaSeleccion = () => {
    return apiClient.get('/usuarios/para-chat');
};

const create = (usuarioData) => {
    return apiClient.post('/usuarios', usuarioData);
};

const update = (id, usuarioData) => {
    return apiClient.put(`/usuarios/${id}`, usuarioData);
};

const remove = (id) => {
    return apiClient.delete(`/usuarios/${id}`);
};

const getPendientes = () => {
    return apiClient.get('/usuarios/pendientes');
};

const validar = (id) => {
    return apiClient.patch(`/usuarios/${id}/validar`);
};

const invalidar = (id) => {
    return apiClient.patch(`/usuarios/${id}/invalidar`);
};

const changePassword = (id, data) => {
    return apiClient.patch(`/usuarios/${id}/password`, data);
};

const updateProfile = (id, data) => {
    return apiClient.patch(`/usuarios/${id}/perfil`, data);
};

const getMe = () => {
    return apiClient.get('/usuarios/me');
};

export const usuarioService = {
    getAll,
    getParaSeleccion,
    create,
    update,
    remove,
    getPendientes,
    validar,
    invalidar,
    changePassword,
    updateProfile,
    getMe,
};
